import OutletWrapper from '@/components/animations/animated-routes/animated-outlet';
import TabSelector from '@/components/page-tabs/page-tab-selector-component';
import { Heading2Text } from '@/utils/global-fonts';
import styled from 'styled-components';

const TabHolder = styled.div`
  padding: 32px;
`;

const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

const noWhiteSpace = { whiteSpace: 'nowrap' };

/**
 * User Management page component.
 * @returns {JSX.Element} The rendered User Management page component.
 */
const UserManagement = () => {
  const tabData = [
    {
      label: 'Users',
      path: '/app/user-management/users',
      permissions: ['user.read'],
    },
    {
      label: 'User Roles',
      path: '/app/user-management/user-roles',
      permissions: ['userRole.read'],
    },
  ];

  return (
    <TabHolder>
      <Heading>
        <Heading2Text style={noWhiteSpace}>User Management</Heading2Text>
        <div id="tabPortal" />
      </Heading>
      <TabSelector tabs={tabData} />
      <OutletWrapper slide={25} slideUp={0} />
    </TabHolder>
  );
};

export default UserManagement;
